import * as RadixDropdownMenu from '@radix-ui/react-dropdown-menu';
import { clsx } from 'clsx';
import type { ComponentPropsWithoutRef } from 'react';
import { dropdownContent, dropdownItem, dropdownSeparator } from './dropdown-menu.css';

export function DropdownMenuRoot(props: RadixDropdownMenu.DropdownMenuProps) {
  return <RadixDropdownMenu.Root modal={false} {...props} />;
}
export const DropdownMenuTrigger = RadixDropdownMenu.Trigger;

export type DropdownMenuContentProps = ComponentPropsWithoutRef<typeof RadixDropdownMenu.Content>;

export function DropdownMenuContent({
  children,
  className,
  sideOffset = 4,
  ...props
}: DropdownMenuContentProps) {
  return (
    <RadixDropdownMenu.Portal>
      <RadixDropdownMenu.Content
        sideOffset={sideOffset}
        className={clsx(dropdownContent, className)}
        {...props}
      >
        {children}
      </RadixDropdownMenu.Content>
    </RadixDropdownMenu.Portal>
  );
}

export type DropdownMenuItemProps = ComponentPropsWithoutRef<typeof RadixDropdownMenu.Item>;

export function DropdownMenuItem({ children, className, ...props }: DropdownMenuItemProps) {
  return (
    <RadixDropdownMenu.Item className={clsx(dropdownItem, className)} {...props}>
      {children}
    </RadixDropdownMenu.Item>
  );
}

export function DropdownMenuSeparator({ className, ...props }: ComponentPropsWithoutRef<typeof RadixDropdownMenu.Separator>) {
  return (
    <RadixDropdownMenu.Separator className={clsx(dropdownSeparator, className)} {...props} />
  );
}
